export default __webpack_public_path__ + "static/media/bfa3aee7359542a01e83127cf255f5e5.svg";